/* Mia reskin — tiny helpers for mia-* sections. No dependencies. */
(function () {
  'use strict';

  /* ---- Click-to-play video cards (self-hosted video, YouTube, Vimeo) ---- */
  function initVideos(root) {
    (root || document).querySelectorAll('[data-mia-video]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '');
      var btn = wrap.querySelector('[data-mia-video-play]');
      var tpl = wrap.querySelector('template');
      if (!btn || !tpl) return;
      btn.addEventListener('click', function () {
        var frag = tpl.content.cloneNode(true);
        btn.remove();
        wrap.appendChild(frag);
        var media = wrap.querySelector('video');
        if (media) {
          media.play().catch(function () { /* user can press play */ });
        }
        var frame = wrap.querySelector('iframe');
        if (frame) frame.focus();
      });
    });
  }

  /* ---- Sticky add-to-cart bar (product page) ---- */
  function initSticky(root) {
    (root || document).querySelectorAll('[data-mia-sticky]:not([data-ready])').forEach(function (bar) {
      bar.setAttribute('data-ready', '');
      var target = document.querySelector('product-form [id^="ProductSubmitButton-"], [id^="ProductSubmitButton-"]');
      var trigger = bar.querySelector('[data-mia-sticky-btn]');
      if (!target || !trigger || !('IntersectionObserver' in window)) return;

      function sync() {
        var off = target.disabled || target.getAttribute('aria-disabled') === 'true';
        trigger.disabled = off;
        var label = target.querySelector('span');
        if (label && label.textContent.trim()) {
          trigger.textContent = label.textContent.trim();
        }
      }
      sync();
      new MutationObserver(sync).observe(target, { attributes: true, childList: true, subtree: true, characterData: true });

      trigger.addEventListener('click', function () {
        if (!target.disabled) target.click();
      });

      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var pastIt = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', pastIt);
        bar.setAttribute('aria-hidden', pastIt ? 'false' : 'true');
        if (pastIt) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
      }, { threshold: 0 }).observe(target);
    });
  }

  function init() { initVideos(); initSticky(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Re-init inside the theme editor when sections are added/edited */
  document.addEventListener('shopify:section:load', function (e) {
    initVideos(e.target);
    initSticky(e.target);
  });
})();
